import buffet from './buffet'
import buffetProducts from './buffetProducts'


export default {
    buffet,
    buffetProducts,
}